const zDictionary = ["sizes",
"crazy",
"prize",
"pizza",
"pizza",
"plaza",
"sized"]; export default zDictionary;